import React from 'react';
import {DatePicker} from 'components';
import {moment} from 'helpers';

export function DatePickerPopup({ value, setValue, popup, ...props }) {
  popup.setClassName('small');
  const setDate = date => {
    setValue(date ? date.unix() : '');
    popup.close();
  };
  return (
    <DatePicker
      {...props}
      value={undefined}
      onChange={setDate}
      selected={moment.parse(value)}
    />
  );
}
